import { http } from "Utils/http";
import { useState, useEffect } from "react";
import { useDispatch } from "react-redux"
import DatatableBase from 'Components/Datatable/DatatableBase'
import { Datatable_Column } from "Components/Datatable/DatatableComponents/DatatableColumn";
import { setGlobalErrorStatus, setGlobalSuccessStatus, setGlobalWarningStatus, setBatchErrorStatus } from 'Components/StatusHandling'
import { ERROR_MESSAGES, WARNING_MESSAGES } from "Utils/constants";
import { store } from 'Store';
import { Col, } from 'react-bootstrap';
import { TextButton } from 'Components/Button';
import ConfirmDeleteBatchPopup from "../Popup/ConfirmDeleteBatchPopup";

const PSETestBatchInProgress = ({ refresh, isPSOPPCAdmin }) => {
  //console.log("PSETestBatchInProgress isPSOPPCAdmin", isPSOPPCAdmin);
  const loginState = store.getState().loginInfo;
  const token = "Bearer " + loginState.token;
  const dispatch = useDispatch();

  // Date format: mm/dd/yyyy hh: mm
  const handleDateFormat = (time) => {

    let date = new Date(time);
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    let hour = date.getHours();
    let min = date.getMinutes();

    return (
      <div>
        {month < 10 ? "0" + month : month}/
        {day < 10 ? "0" + day : day}/
        {year + " "}
        {hour < 10 ? "0" + hour : hour}:
        {min < 10 ? "0" + min : min}
      </div>
    )
  }


  /** Start of inProgressPSETestBatch */
  const inProgressPSETestBatchRowSelection = true;
  const inProgressPSETestBatchHeader = "Test Data Submission Activity";
  const inProgressPSETestBatchSearchFieldText = "Search by ID";
  const inProgressPSETestBatchSortId = 'submitDate';
  const inProgressPSETestBatchSortOrder = 'desc';


  // Flag: trigger api to reload data
  const [reloadInProgressPSETestBatch, setReloadInProgressPSETestBatch] = useState(false);

  // const [inProgressPSETestBatchSortColumn, setInProgressPSETestBatchSortColumn] = useState({
  //   sortField: "submitDate",
  //   sortDirection: "desc"
  // });
  const [selected, setSelected] = useState(
    {
      allSelected: false,
      selectedCount: 0,
      selectedRows: []
    }
  );
  const [showDeletePopup, setShowDeletePopup] = useState(false);

  // Trigger reload InProgressPSETestBatches
  useEffect(() => {
    setReloadInProgressPSETestBatch(refresh);
  }, [refresh]);

  const getListCols = (selectedList, sortingInfo) => {
    const listColumns = [];

    const nameState = function ({ rowName }) {
      //console.log("print out getListCols", rowName);
      return { id: rowName.id };
    }
    listColumns.push(Datatable_Column({ name: "PSO ID", columnName: "submitPsoId", selectedRows: selectedList, sortable: true, sortFieldNum: 0, sortingInfo: sortingInfo }))
    listColumns.push(Datatable_Column({ name: "Batch ID", columnName: "id", selectedRows: selectedList, sortable: true, sortFieldNum: 0, isLink: true, linkData: { title: "", pathname: "/eventDataSubmission/displayBatchDetail", text: null, state: nameState }, sortingInfo: sortingInfo }))

    listColumns.push(Datatable_Column({ name: "Setting", columnName: "cfSetting", selectedRows: selectedList, sortable: true, sortFieldNum: 1, sortingInfo: sortingInfo }))
    listColumns.push(Datatable_Column({ name: "No of Files", columnName: "fileCount", selectedRows: selectedList, sortable: true, sortFieldNum: 2, sortingInfo: sortingInfo }))
    listColumns.push(Datatable_Column({ name: "Batch Status", columnName: "batchStatus", selectedRows: selectedList, sortable: true, sortFieldNum: 3, sortingInfo: sortingInfo }))
    listColumns.push(Datatable_Column({ name: "Submission Date", columnName: "submitDate", selectedRows: selectedList, sortable: true, sortFieldNum: 4, formatFunction: handleDateFormat, sortingInfo: sortingInfo }))

    return listColumns;
  }

  const submitDeletedBatches = async (batchIdList) => {
    const call = {
      batchId: batchIdList,
    }

    const url = '/api/cda/deleteBatch';

    return http.post(url, call, {
      headers: {
        "Authorization": "Bearer " + loginState.token,
      },
    }).catch((error) => {
      //console.log("error submitDeletedBatches()", error);
      setGlobalErrorStatus({
        dispatch: dispatch,
        popupData: {
          visible: true,
          title: ERROR_MESSAGES.DATA_ERROR.title,
          msg: ERROR_MESSAGES.DATA_ERROR.message,
          showContactHelp: true
        },
        redirect: {
          redirect: false,
          redirectFirst: false,
          path: "",
          data: {}
        },
        error: error
      });
    });
  }

  const deleteInProgressPSETestBatch = async (batchList) => {
    const batchIdList = selected.selectedRows?.map((item) => item.id);
    const res = await submitDeletedBatches(batchIdList);
    //console.log("print out deleteInProgressPSEProdBatch batchlist", res);
    if (res?.status == -1) {
      let msg = res?.globalErrorMessageList;
      msg.unshift(res?.message);
      // set error popup
      setBatchErrorStatus({
        dispatch: dispatch,
        popupData: {
          visible: true,
          //title: ERROR_MESSAGES.DATA_ERROR.title,
          title: "Error",
          msg: msg,
          showContactHelp: false
        },
        redirect: {
          redirect: false,
          redirectFirst: false,
          path: "",
          data: {}
        },
      });
      // setGlobalErrorStatus({
      //   dispatch: dispatch,
      //   popupData: {
      //     visible: true,
      //     title: ERROR_MESSAGES.DATA_ERROR.title,
      //     msg: msg,
      //     showContactHelp: false
      //   },
      //   redirect: {
      //     redirect: false,
      //     redirectFirst: false,
      //     path: "",
      //     data: {}
      //   },
      // });
      return;
    } else if (res?.status == -4) {
      //message: globalErrorMessageList + message
      let msg = res?.globalErrorMessageList;
      msg.unshift(res?.message);
      // set warning popup
      setGlobalWarningStatus({
        dispatch: dispatch,
        popupData: {
          visible: true,
          title: WARNING_MESSAGES.WARNING.title,
          msg: msg,
          showContactHelp: false
        },
        redirect: {
          redirect: false,
          redirectFirst: false,
          path: "",
          data: {}
        },
      });
      // refresh datatable
      setReloadInProgressPSETestBatch(true);
      return;
    }

    // refresh datatable
    setReloadInProgressPSETestBatch(true);
    // set success popup
    setGlobalSuccessStatus({
      dispatch: dispatch,
      popupData: {
        visible: true,
        title: "Success!",
        msg: res.message,
        showContactHelp: false
      },
      redirect: {
        redirect: false,
        redirectFirst: false,
        path: "",
        data: {}
      }
    })
  }

  const getData = async (filter) => {
    var call = {
      paginationRequest: filter,
      isTestSubmission: "Y"
    }
    //console.log("CALL", call, loginState);
    var url = '/api/cda/inProgressBatch';

    return http.post(url, call, {
      headers: {
        "Authorization": token
      }
    });
  }

  const getDeleteBatchesText = () => {
    if (selected.selectedCount > 1) {
      return "Delete Selected Batch(es)";
    }
    else {
      return "Delete Selected Batch";
    }
  }
  const rowDisabledCriteria = (row) => {
    if (row.batchStatus == "Received" && isPSOPPCAdmin == true) {
      return false;
    } else {
      return true;
    }
  }

  const handleShowDeletePopup = () => {
    setShowDeletePopup(true);
  }

  const handleCloseDeletePopup = () => {
    setShowDeletePopup(false);
  }

  return (
    <>
      <ConfirmDeleteBatchPopup
        show={showDeletePopup}
        handleClose={handleCloseDeletePopup}
        handleDelete={deleteInProgressPSETestBatch}
        selected={selected}
      >
      </ConfirmDeleteBatchPopup>
      <DatatableBase
        tableClassName="cdaTestInProgressTable"
        rowDisabledCriteria={rowDisabledCriteria}
        reload={reloadInProgressPSETestBatch}
        setReload={setReloadInProgressPSETestBatch}
        getData={getData}
        getListCols={getListCols}
        setSelected={setSelected}
        hasSelectableRows={inProgressPSETestBatchRowSelection}
        searchFieldText={inProgressPSETestBatchSearchFieldText}
        datatableHeader={inProgressPSETestBatchHeader}
        datatableDescription={null}
        sortingColumn={inProgressPSETestBatchSortId}
        sortingOrder={inProgressPSETestBatchSortOrder}
      >
        {
          <Col className="d-flex justify-content-end ">
            <TextButton
              className="ms-auto"
              onClick={handleShowDeletePopup}
              variant="normal"
              content={getDeleteBatchesText()}
              disabled={selected.selectedCount < 1 ? true : false}
            />
          </Col>
        }
      </DatatableBase>
    </>
  )
}

export default PSETestBatchInProgress;